import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/cpa/cpa-course/PageContent.tsx");
